import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterNavLink } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import { CitizenIcon, ArrowLeftIcon } from '#web-components/components/Icons';
import Typography from '#web-components/components/Typography';
import InlineButton from '#web-components/components/InlineButton';

import styles from './NotificationsEmptyPlaceholder.styles';

const useStyles = makeStyles(styles, { name: 'NotificationsEmptyPlaceholder' });

const emptyPlaceholderLinks = [
  {
    title: 'domains:appSections.processDefinition.title',
    path: ROUTES.PROCESS_LIST,
  },
  {
    title: 'components:header.profile',
    path: ROUTES.PROFILE,
  },
];

export default function NotificationsEmptyPlaceholder() {
  const classes = useStyles();
  const { t } = useTranslation('pages');

  return (
    <div className={classes.root}>
      <CitizenIcon variant="h1" />
      <Typography variant="textRegular" className={classes.title}>
        {t('notificationList.emptyPlaceholder.title')}
      </Typography>
      <br />
      <Typography variant="textRegular">{t('notificationList.emptyPlaceholder.message')}</Typography>
      {emptyPlaceholderLinks.map(({ title, path }) => (
        <InlineButton
          key={path}
          size="large"
          leftIcon={<ArrowLeftIcon />}
          component={RouterNavLink}
          to={path}
          classes={{ link: classes.link }}
        >
          {t(title)}
        </InlineButton>
      ))}
    </div>
  );
}
